import { Grid, Typography } from "@mui/material";

import Section from "../components/Section";
import SubTitleHeader from "../components/SubTitle";
import TicketOptionTile from "./TicketOptionTile";
import List from "../components/list";
import { YEAR } from "../constants/festivalDates";
// import { HashLink } from "react-router-hash-link";
// import {
//   textDecoration,
//   linkStyles,
// } from "../FestivalInformation/FestivalInformationScreen";

const TicketingInformationScreen = () => {
  return (
    <Grid container>
      <Section title="Tickets">
        <SubTitleHeader subTitle="General Ticketing Info" />

        <List
          items={[
            `Everyone attending Amplitude Festival ${YEAR}, must both arrive with a ticket and in a vehicle with a vehicle/camping pass.`,
            "Tickets and passes will be on sale by April 27th",
            "All tickets and passes require a promo code to unlock. The channel or person you heard about Amplitude from can provide you with the code to purchase.",
            "Gates open starting at 4pm on Friday. All attendees and vehicles must leave the site by 3:30pm on Sunday.",
            "All sales are final.",
          ]}
        />
      </Section>

      {/* General Camping Ticket */}
      <Section>
        <Grid container>
          <Grid item sx={{ flex: 1 }}>
            <SubTitleHeader
              anchor="GeneralCampingTicket"
              subTitle="General Vehicle Pass/Camping"
            />
            <Typography
              sx={{
                fontSize: 14,
                paddingRight: { xs: "10px", sm: "40px", md: "100px" },
              }}
              color="primary"
              paragraph
            >
              All tickets and passes require a promo code to unlock. The channel or person you heard about Amplitude from can provide you with the code to purchase.
              <br />
              <br />
              Your vehicle pass/camping pass is for one camping spot that is approximately 18’ x
              40’, with enough room for 2 four-person tents and one vehicle or
              an RV. A max of 1 vehicle and 6 people are allowed per campsite.
              <br />
              <br />
              All camping passes have identical access to the festival. Later tiers will become available
              every week as the festival gets closer to encourage people to buy early so we can properly account for 
              expected capacity.
              <br />
              <br />
              Want to support our vision? Purchase a higher tier than the cheapest available tier.
              <br />
              <br />
              We would love nothing more than to sell out the
              festival in our cheapest tier. Amplitude is not a profit-driven festival, any excess
              income will be reinvested to add to the experience of this or a future event.
            </Typography>
          </Grid>
          <Grid item sx={{ width: { xs: "100%", md: "unset" } }}>
            <TicketOptionTile
              cost="195"
              costMax="215"
              link="https://aftontickets.com/event/buyticket/7pj6nlzg9r?ticket_group=camping-vehicle-pass"
            />
          </Grid>
        </Grid>
      </Section>

      {/* Admission */}
      <Section>
        <Grid container>
          <Grid item sx={{ flex: 1 }}>
            <SubTitleHeader
              anchor="GeneralAdmission"
              subTitle="General Admission Ticket"
            />
            <Typography
              sx={{
                fontSize: 14,
                paddingRight: { xs: "10px", sm: "40px", md: "100px" },
              }}
              color="primary"
              paragraph
            >
              All tickets and passes require a promo code to unlock. The channel or person you heard about Amplitude from can provide you with the code to purchase.
              <br />
              <br />
              All tickets to Amplitude festival are general admission, and every attendee must have one.
              <br />
              <br />
              All tickets have identical access to the festival. Later tiers will become available
              every week as the festival gets closer to encourage people to buy early so we can properly account for 
              expected capacity.
              <br />
              <br />
              Want to support our vision? Purchase a higher tier than the cheapest available tier.
              <br />
              <br />
              We would love nothing more than to sell out the
              festival in our cheapest tier. Amplitude is not a profit-driven festival, any excess
              income will be reinvested to add to the experience of this or a future event.
            </Typography>
          </Grid>
          <Grid item sx={{ width: { xs: "100%", md: "unset" } }}>
            <TicketOptionTile
              cost="80"
              costMax="125"
              link="https://aftontickets.com/event/buyticket/7pj6nlzg9r?ticket_group=admission"
            />
          </Grid>
        </Grid>
      </Section>
    </Grid>
  );
};

export default TicketingInformationScreen;
